import { render, staticRenderFns } from "./AppAlertsServiceOrders.vue?vue&type=template&id=1054b9ea&scoped=true&"
import script from "./AppAlertsServiceOrders.vue?vue&type=script&lang=js&"
export * from "./AppAlertsServiceOrders.vue?vue&type=script&lang=js&"
import style0 from "./AppAlertsServiceOrders.vue?vue&type=style&index=0&id=1054b9ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1054b9ea",
  null
  
)

export default component.exports